import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type useGetCollectionQuery } from 'domains/collections/api'
import { CollectionsList } from 'domains/collections/components/collections-list/components/list/CollectionsList'
import { useChildCollectionsListColumns } from 'domains/collections/components/collections-form/components/child-collections/utils/childCollectionsListColumns.hooks'

interface CollectionsChildCollectionsProps {
  childCollections: ReturnType<typeof useGetCollectionQuery>['data']['collection']['children']
}

const wrapper = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: 350,
})

export const CollectionsViewChildCollections: FunctionComponent<
  CollectionsChildCollectionsProps
> = ({ childCollections }) => {
  const title = useDomainMessage('collectionsDomain.collectionsForm.section.childCollections.title')

  const columns = useChildCollectionsListColumns({})

  return (
    <div css={wrapper}>
      <Text styles={css({ marginLeft: 0 })} size="medium" weight="semibold">
        {title}
      </Text>

      <CollectionsList
        columns={columns}
        collections={childCollections ?? []}
        apiLoading={false}
        apiError={undefined}
        canLoadMore={false}
        loadMore={undefined}
        refetch={undefined}
      />
    </div>
  )
}
